module.exports = __webpack_public_path__ + "static/media/left_arrow_icon.4fb8717c.svg";